module.exports = __webpack_public_path__ + "static/media/Four-Layer-Bkfst-Bowl-Bundle_780x390.b800d618.jpg";